import React from 'react';

const WalletSetupSkeleton = () => (
  <div className="max-w-md mx-auto bg-white rounded-lg shadow p-8 animate-pulse">
    <div className="h-6 bg-gray-200 rounded w-1/2 mb-6"></div>
    <div className="space-y-4">
      <div className="h-4 bg-gray-200 rounded w-full"></div>
      <div className="h-4 bg-gray-200 rounded w-5/6"></div>
      <div className="h-4 bg-gray-200 rounded w-2/3"></div>
    </div>
    <div className="mt-8 h-10 bg-gray-200 rounded w-full"></div>
  </div>
);

export default WalletSetupSkeleton;
